<template lang="pug">
  v-app
    v-toolbar(app='' color="#FFDB04" height="100")
      v-toolbar-title.headline.text-uppercase
        router-link(to='/')
          svg.logo-img(v-html="svg")
      v-spacer
      v-toolbar-items
        v-btn.btn-menu.hidden-sm-and-down(large, :ripple="false", v-for='(item,index) in menu', :key='index' flat @click="clickTab(item)") {{item.title}}
      v-menu.hidden-md-and-up
        v-toolbar-side-icon(slot='activator')
        v-list
          v-list-tile.btn-menu(v-for='item in menu', :key='item.id')
            v-list-tile-content
              v-list-tile-title(@click="clickTab(item)") {{ item.title }}

    router-view
    v-footer(dark='', height='auto' )
      v-card.flex(flat='', tile='')
        v-card-title.footer-title
          v-layout(align-center justify-center fill-height row wrap)
            v-flex(xs10 offset-xs0 md5)
              span.footer-text 投投是道：高級中等學校模擬投票暨選民教育計畫
              br
              span.footer-text 指導單位：教育部國民及學前教育署
            v-flex(xs10 offset-xs0 md5)
              span.footer-text 承辦單位：國立臺南第一高級中學、台灣少年權益與福利促進聯盟
              br
              span.footer-text 協辦單位：全國68所高級中等學校
            v-flex(xs10 offset-xs0 md5)
              a.footer-icon.footer-text(:href="icons[0].link" target="_blank")
                i(class="fab fa-facebook-square")
                span &ensp;投票正義，十八開始
            v-flex(xs10 offset-xs0 md5)
              a.footer-icon.footer-text(:href="icons[1].link" target="_blank")
                i(class="fab fa-facebook-square")
                span &ensp;台灣少年權益與福利促進聯盟
          
        v-card-actions.grey.darken-3.justify-center.footer-text
          | ©2019 — 教育部國民及學前教育署｜投投是道：高級中等學校模擬投票暨選民教育計畫
</template>

<script>
export default {
  data: () => {
    return {
      menu: [
        {
          title: "投下第一票",
          anchor: "news"
        },
        {
          title: "活動簡介",
          anchor: "about"
        },
        {
          title: "選民教育",
          anchor: "content"
        },
        {
          title: "台灣現況",
          anchor: "taiwan"
        },
        {
          title: "問與答",
          anchor: "faq"
        },
        {
          title: "補充資源",
          anchor: "more",
          external_link: "http://bit.ly/U20voteBOOK"
        }
      ],
      svg:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 348.61 92.35"><defs><style>.cls-1,.cls-2{fill:none;stroke:#000;}.cls-1{stroke-width:10px;}.cls-2{stroke-linecap:square;stroke-width:7px;}</style></defs><title>logo_text</title><g id="Layer_2" data-name="Layer 2"><g id="logo_text"><g id="道"><ellipse id="Oval" class="cls-1" cx="310.79" cy="51.06" rx="22.4" ry="17.79" transform="translate(44.8 219.72) rotate(-41.71)"/><path id="Line" class="cls-2" d="M295.56,63.28,324.87,45"/><path id="Line-Copy" class="cls-2" d="M295.39,41.72l15.22,8.1"/><g id="頭"><path id="Path-Copy-2" d="M302.44,16.43c-1-1.74-2.52-5.49-3.54-7L307.56,3c1.62,2.32,3.91,5.46,5.12,7.43l-2.48,2Z"/><path id="Path-Copy-3" d="M319.57,12.3A133.62,133.62,0,0,0,328.15,0l11.61,3.64c-2.22,2.4-6.65,8.83-8.69,10.87Z"/><path id="Path-Copy-4" d="M284.52,26.8l2.26-9.57a158.83,158.83,0,0,1,29.75-5.36c15.14-1.27,22.82-.87,32.08-3.06-1.79,3.43-3.41,8-7.21,13.82-7.48-.06-17.1.13-26.51.36Q305.47,23.22,284.52,26.8Z"/></g><g id="ticket"><path id="Combined-Shape" d="M281.37,21.12l-12.75,5.14c-.17-1.7-.75-5.06-1.74-10.1l3.73-7.07,7.64-2.86C279.29,11,280.66,17.08,281.37,21.12Zm-7.84-2.19-2.45-.64-1,2.14,4.73.89,3.34-9.14-2.34-.31Zm-5.7-3,3.95-1.71L270.94,10Z"/></g><path id="Path" d="M273.09,58.48c2.92,4.36,4,4.8,6.47,12.94,1.09.82,2.39,1.92,4.05,3,5.23,3.83,14,4.29,24.56,4.29,9.86,0,23.3-3.29,33.81-4.93a56.19,56.19,0,0,0-7,13.51c-8.06.54-19.68,3.46-30.27,3.46-12.23,0-19.57-1-25.3-4.65-3.32-2.19-2.95-3.56-4.57-5.84-6.39,3.11-13.52,5.84-20.27,8.61-.23,1-3.11,1.11-3.11,1.11,3-3.19,6.59-11.27,6.83-12.31,1.85-.57,7.23-2.48,9.45-6.26s-6.72-7.69-9.73-9.81C262.68,60.52,270.34,59,273.09,58.48Z"/><path id="Path-Copy" d="M303.94,34.33q-2.06.95-3.77-3.17c4.18-3.29,6.77-5,16.54-13.7,2.06,0,7-1.24,7.14.93a105.36,105.36,0,0,0-12.6,10A39.83,39.83,0,0,1,303.94,34.33Z"/></g><g id="投_2" data-name="投 2"><path id="Path-Copy-12" d="M178,51.55a51.54,51.54,0,0,1-13.54,17.91c-6.93,5.53-8.54,6.66-13,9.12-7.44,4.2-27.91,11.73-41.38,11.07a13.38,13.38,0,0,0,6-4c2.31-2.51,3.32-6.84,3.63-8.19,7.61-1.37,12.5-3.77,22.4-8.1a47.43,47.43,0,0,0,12.08-7.67c4.33-3.5,6.9-7.25,9.19-10.15Z"/><path id="投-copy-2" d="M161.9,73.4c2.86,2,7.16,3.17,14.72,4.85-3.28,5.7-7.78,9.12-11.85,11.91-7.91-2.1-11.09-3.33-15.39-7.21a40.59,40.59,0,0,1-8.14-9.22c-3-4.3-8.31-10.73-9.33-14.73a93.59,93.59,0,0,1,14.76-3.94C147.9,64,155.55,68.5,161.9,73.4Z"/><path id="Path-Copy-5" d="M137.74,40.93l1.84-.06c-1.49-2.67-4.51-6.82-6.32-8.3a22.15,22.15,0,0,0,3.21-1.92l1.06-.76c6.5-4.75,8.23-10.34,9.22-15.35l1.84-9.4L182.6,4l-3.66,18.7c-.54,2.74-.41,3,.42,3,2.57-.09,2.67-.09,4.49-8.48,2,1.83,6.79,3.56,9.94,4.27C190.49,32.68,186.9,36.06,180,36.3l-5.33.18c-8.64.3-10.59-2.8-8.56-13.2l1.31-6.65-8.83.3c-2,8.22-6.42,17.43-16.54,23.85Z"/><g id="扌"><path id="Path-Copy-9" d="M118.05,76.38c-2.13,9.23-5.56,13.4-17.45,14.23-1.52.1-14.47-.3-16.27-.3A44.25,44.25,0,0,0,95.7,78.12c3.15.18,6,0,7.16,0s1.84-.46,2.14-1.74L122.07,2.43l15.64.64c-.34,1.09-1.24,1.82-3.22,2.09Z"/><polygon id="Path-Copy-8" points="137.1 27.95 107.86 29.46 110.04 17.25 140.2 15.69 138.15 27.17 137.1 27.95"/></g></g><g id="投"><path id="Path-Copy-11" d="M90.66,52.31a75.12,75.12,0,0,1-14.5,17.15c-6.93,5.53-8.54,6.66-13,9.12a96.1,96.1,0,0,1-22.5,9c-.8.21-12.11,3.81-15.86,3.58a11.14,11.14,0,0,0,5.56-4.32c1.66-2.28,3-8,3.64-10.83,7.62-1.37,11.08-2.27,21-6.6A47.24,47.24,0,0,0,67.09,61.7a52.67,52.67,0,0,0,9-9.39Z"/><path id="投-copy-2-2" data-name="投-copy-2" d="M75.24,71.12c5.23,3.38,10.88,5.32,18.45,7-2.37,4.13-7.54,9.26-11.54,12-7.91-2.1-15.13-5.61-19.44-9.49s-5.57-4.28-9.53-8.08a34.73,34.73,0,0,1-6.36-8.81,72.52,72.52,0,0,1,13.11-3.26C62.74,63.85,67.37,67.41,75.24,71.12Z"/><path id="Path-Copy-5-2" data-name="Path-Copy-5" d="M49.52,43.63l1.84-.07c-1.49-2.66-6.48-6.05-8.29-7.53a45.64,45.64,0,0,0,5.19-3.09c6.5-4.75,10.28-13.43,11.26-18.44l1.84-9.4,34-1.17-4.11,21c-.53,2.74-.4,3,.43,3,2.57-.08,2.66-.09,4.49-8.48,2,1.83,6.79,3.56,9.94,4.27-3.31,11.26-6.89,14.64-13.78,14.88L87,38.72c-8.64.3-10.14-5.08-8.1-15.47l1.3-6.66-8.82.3c-2,8.22-7.42,20.17-17.54,26.59Z"/><g id="扌-2" data-name="扌"><path id="Path-Copy-9-2" data-name="Path-Copy-9" d="M31.47,78.66C29.07,89.07,25.21,92.35,9,92.35a42,42,0,0,0-.76-12.13c3.15.18,6.89.18,8.08.18s1.84-.46,2.13-1.74L36,2.43l15.63.64c-.34,1.09-1.24,1.82-3.22,2.09Z"/><polygon id="Path-Copy-8-2" data-name="Path-Copy-8" points="49.96 28.49 18.24 31.21 19.99 19.03 52.63 16.23 50.99 27.68 49.96 28.49"/></g></g><path id="日" d="M204,4.24l56.52-1-7,32.66L197,36.9ZM216.49,16l32.43-.56.62-2.92-32.43.56ZM214,27.52,246.47,27l.64-3-32.43.57Z"/><path id="Path-2" data-name="Path" d="M0,69.12A155.87,155.87,0,0,0,7.84,48.59Q50,38.87,270.49,38.85l-6.41-10.77h13.19l8.67,16.27-13.15,13-13.87,2.86,8.94-10Q56.18,52.42,0,69.12Z"/><path id="Path-Copy-10" d="M244.81,69.54H227.93l-1.8,7.8c3.52.18,7.81.18,14.47.18,7.66,0,10.82.64,16.52.46-2,5.56-5,10.26-6.8,12.17l-19.5-.31c-16,0-30-2.1-35.54-11.86-3.37,4-18.41,11.67-20.74,11.86s-6.61.65-7.5.38c5.35-3.42,8.56-7.41,11.89-12C182.29,79.39,191,68,194.9,56l17.77-2.85A7.62,7.62,0,0,1,209.73,56c-.88,1.83-3.07,8.27-4,10,1.19,4.75,3.35,7,7.33,8.79l5.5-23.87,2.12-9.18,13.7,0-2.13,9.22-1.66,7.21h18.62Z"/></g></g></svg>',
      link: [{}],
      icons: [
        { icon: "fab fa-facebook", link: "https://www.facebook.com/18vote/", page: "投投是道" },
        { icon: "fab fa-facebook", link: "https://www.facebook.com/youthright/", page: "台灣少年權益與福利促進聯盟" }

      ],
      footerInfo: []
    };
  },
  components: {},
  methods: {
    clickTab(item) {
      if (this.$route.name === "home" && item.anchor !== "more") {
        let link = "#" + item.anchor;
        this.$vuetify.goTo(link, { offset: 50, easing: "easeOutQuad" });
      } else if (item.anchor === "more") {
        var win = window.open(item.external_link, "_blank");
        win.focus();
      } else {
        this.$router.push("/", () => {
          this.$nextTick(() => {
            let target = document.getElementById(item.anchor);
            window.scrollTo(0, target.offsetTop - 50);
          });
        });
      }
    }
  }
};
</script>

<style lang="scss">
.headline {
  position: relative;
  height: 100%;
}

.logo-img {
  margin-top: 15px;
  height: 70%;
  fill: #152147;
  .cls-1,
  .cls-2 {
    stroke: #152147;
  }
}

.intro-logo {
  height: auto;
  // stroke: #152147;
  fill: #152147;
  .cls-1,
  .cls-2 {
    stroke: #152147;
  }
}

.v-btn.btn-menu {
  padding: 16px !important;
  position: relative;
  transition: 0.5s;
  :after {
    content: "";
    display: block;
    border-bottom: 2px solid black;
    width: 0;
    bottom: 0;
    position: absolute;
    left: 0;
    -webkit-transition: 0.5s ease;
    transition: 0.5s ease;
  }
  :hover:after {
    transition: 0.5s;
    width: 100%;
  }
}

.v-btn:before,
.v-btn:hover:before,
.v-btn:focus:before {
  opacity: 0 !important;
  color: transparent !important;
}

.v-btn__content {
  font-size: 1.2em;
}

.footer-title {
  display: flex;
  flex-direction: row;
  align-items: flex-start !important;
  justify-content: center;
  background-color: #152147;
}

.footer-text {
  font-size: 14px;
  line-height: 36px;
}

.footer-icon{
  text-decoration: none;
  color: white;
}
</style>